// The consent texts moved into the backend admin panel and are kept as revisions. A published
// revision is never edited: a reworded text becomes a new version and the previous one stays
// forever, because people agreed under exactly that wording.
//
// The version therefore belongs to the backend, not to us. It is read from the endpoint and
// echoed back untouched with the consent, which is what makes publishing a new revision a
// backend-only act - no frontend release, nothing to keep in step by hand.
//
//   GET v1/consent-texts        public, no auth, no cache, X-localization picks the language
//
// The response carries the *current* revision of each kind, never the whole history. A kind
// that has not been published yet is simply absent, so the array can be empty or partial and
// the order means nothing - never index into it. While a kind is unpublished the backend
// accepts any version for it, which is what lets this ship before a single text exists.

export const CONSENT_TEXT_KIND = {
  CHECKOUT_MARKETING: 'checkout_marketing',
  COOKIE_LIST: 'cookie_list',
  COOKIE_BANNER: 'cookie_banner',
  PRIVACY_POLICY: 'privacy_policy',
}

export const CONSENT_TEXT_KINDS = [
  CONSENT_TEXT_KIND.CHECKOUT_MARKETING,
  CONSENT_TEXT_KIND.COOKIE_LIST,
  CONSENT_TEXT_KIND.COOKIE_BANNER,
  CONSENT_TEXT_KIND.PRIVACY_POLICY,
]

// `body` is always a string. For these two it holds JSON that has to be parsed; for the other
// two it is ready markup that goes in as HTML.
export const JSON_BODY_KINDS = [
  CONSENT_TEXT_KIND.CHECKOUT_MARKETING,
  CONSENT_TEXT_KIND.COOKIE_LIST,
]

// Only these three locales have prepared texts. Every other locale is served the Czech original
// on purpose - a document in Czech beats an empty page - so the `locale` field of the response
// is the one to trust, never the language that was asked for.
export const CONSENT_TEXT_LOCALES = ['cz', 'en', 'ru']
